import React from 'react';
import { RedocStandalone } from 'redoc';

const ApiDocs = () => {
  return (
    <div style={{ marginTop: '20px' }}>
      <RedocStandalone
        specUrl="/openapi.yaml" // Points to the file in the public folder
        options={{
          nativeScrollbars: true,
          theme: { colors: { primary: { main: '#dd5522' } } },
        }}
      />
    </div>
  );
};

export default ApiDocs;
